export default "__VITE_ASSET__cf874efd__"